import { FirebaseAuth } from "firebase-config";
import { onAuthStateChanged } from "firebase/auth";
import { useAppDispatch, useAppSelector } from "hooks";
import { useEffect } from "react"
import { logout } from "store/auth";
import { LoadingPage } from "components";
import { validateAuth } from "services";
import { SignInPage } from "app/auth";
import { DashboardDynamicPage } from "app/dashboard-dynamic";
import { SellersControlPage } from "app/seller-control";
import { GondolaColdPage } from "app/gondola-cold";
import { InventoryPage } from "app/inventory";
import { OrdersPage } from "app/orders";
import { AddIvaCardPage, IvaCardDetailPage, IvaCardsPage } from "app/iva-cards";
import AdminCat from "app/adminCat/pages/AdminCat";
import { HomePage } from "app/home";
import { loadAccessPermits } from "store/settings";
import ReportePromo from "app/reporte-promo/pages/ReportePromo";
import OnSix from "app/on-six/index";
import OnSixCostumer from "app/on-six/OnSixCostumer";
import OnSixRatingDetails from "app/on-six/OnSixRatingDetails";

import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProductDetailReport from "app/on-six/ProductDetailReport";

const routes: {
    path: string;
    component: React.ComponentType<any>;
    permission: string;
}[] = [
    { path: "/auth/signin", component: SignInPage, permission: "signin" },
    { path: "/home", component: HomePage, permission: "home" },
    { path: "/dashboard", component: DashboardDynamicPage, permission: "dynamic_dashboard" },
    { path: "/sellersControl", component: SellersControlPage, permission: "sellers_control" },
    { path: "/gondolaCold", component: GondolaColdPage, permission: "gondola_cold" },
    { path: "/inventory", component: InventoryPage, permission: "inventory" },
    { path: "/orders", component: OrdersPage, permission: "orders" },
    { path: "/ivaCards", component: IvaCardsPage, permission: "iva_cards" },
    { path: "/on-six", component: OnSix, permission: "on6" },
    { path: "/on-six/costumer/:costumerID", component: OnSixCostumer, permission: "on6" },
    { path: "/on-six/rating/:ratingID", component: OnSixRatingDetails, permission: "on6" },
    { path: "/on-six/brands/:productID", component: ProductDetailReport, permission: "on6" },
    { path: "/ivaCards/:cardKey", component: IvaCardDetailPage, permission: "iva_cards" },
    { path: "/ivaCards/add", component: AddIvaCardPage, permission: "iva_cards" },
    { path: "/administracionCategorias", component: AdminCat, permission: "benchmarks_report" },
    { path: "/reportePromocion", component: ReportePromo, permission: "benchmarks_report_promotions" },

];

//permisson es la key asignada a ese rol para que el rol la pueda ver, ejem para que un rol pueda ver la parte de inventario tiene que tener asignada la palabra inventario 

export const MainRouter = () => {
    const { authStatus } = useAppSelector(state => state.auth);
    const { accessPermits } = useAppSelector(state => state.settings);

    const dispatch = useAppDispatch();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(FirebaseAuth, (user) => {
            if (user) validateAuth(dispatch);
            else {
                const accessPermitsAux = ["signin"];

                dispatch(loadAccessPermits(accessPermitsAux));

                dispatch(logout());
            }
        });

        // Limpia el listener cuando el componente se desmonte
        return () => unsubscribe();
    }, [dispatch]);

    if (authStatus === "checking") {
        return <LoadingPage />
    }

    return (
        <Router>
            <Routes>
                {routes.map((route) => {
                    const Component = route.component;
                    const allowed = accessPermits.includes(route.permission);

                    // Si está permitido renderiza el componente, si no redirige según authStatus
                    if (allowed) {
                        return <Route key={route.path} path={route.path} element={<Component />} />;
                    }

                    // No permitido: redirigir a /home si ya autenticado, sino a /auth/signin
                    const to = authStatus === "authenticated" ? "/home" : "/auth/signin";
                    return <Route key={route.path} path={route.path} element={<Navigate to={to} replace />} />;
                })}

                {/* Ruta por defecto: si el usuario está autenticado ir a /home, sino a /auth/signin */}
                <Route path="*" element={<Navigate to={authStatus === "authenticated" ? "/home" : "/auth/signin"} replace />} />
            </Routes>
        </Router>
    )
}